module.exports = __webpack_public_path__ + "img/icon-inprocess.6c0588cd.png";